
import React from 'react';

const HourGlassUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M10.87 28H21.5c.55 0 1-.45 1-1v-5.05c0-2.99-2.28-5.47-5.26-5.95 2.98-.49 5.26-2.97 5.26-5.95V5c0-.55-.45-1-1-1H10.87c-.55 0-1 .45-1 1v5.05c0 2.99 2.28 5.47 5.26 5.95-2.98.49-5.26 2.97-5.26 5.95V27c0 .55.44 1 1 1zm1-2v-1.38h8.63V26h-8.63zM20.5 6v2.29h-8.63V6h8.63zm-8.61 4.29h8.58c-.14 2.11-2 3.8-4.29 3.8s-4.15-1.68-4.29-3.8zm4.29 7.62c2.38 0 4.32 1.81 4.32 4.05v.66h-8.63v-.66c0-2.24 1.93-4.05 4.31-4.05zM23 30H9v2h14v-2z'
			></path>
		</svg>
	);
};

export default HourGlassUnderline;
